<template>
  <v-container fluid style="height:100%; padding-top:1px !important" pa-0 ma-0>
    <v-row no-gutters fill-height>
      <OrdersTable />
    </v-row>
  </v-container>  
</template>
<script>
import OrdersTable from './../../components/blocks/OrdersTable'


export default {
    components: {
      OrdersTable,
    },
    data () {
      return {
        
      }
    },
    mounted() {
    },
    computed: {

    },
    created () {},
    methods: {
      
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Orders.vue